export const base = '';

export const routes = {
  /**
   * Base
   */
  HOME: [base, '/'].join(''),

  /**
   * Errors
   */
  ERROR_401: [base, '/error/unauthorized'].join(''),
  ERROR_403: [base, '/error/forbidden'].join(''),
  ERROR_404: [base, '/error/not-found'].join(''),
  ERROR_500: [base, '/error/server-error'].join(''),

  /**
   * Auth
   */
  LOGIN: [base, '/auth/login'].join(''),
  REGISTER: [base, '/auth/register'].join(''),
  FORGOT_PASSWORD: [base, '/auth/forgot-password'].join(''),
  RESET_PASSWORD: [base, '/auth/reset-password'].join(''),
  CONFIRM_MAIL: [base, '/auth/confirm-mail'].join(''),
  ACTIVATE: [base, '/auth/activate'].join(''),
  LOCK: [base, '/auth/locked'].join(''),
  MFA_APP_SETUP: [base, '/auth/mfa'].join(''),
  MFA_APP_VERIFY: [base, '/auth/otp'].join(''),

  /**
   * Overview
   */
  OVERVIEW: [base, '/overview'].join(''),

  /**
   * Account
   */
  ACCOUNT: [base, '/account'].join(''),
  ACCOUNT_PROFILE: [base, '/account/profile'].join(''),
  ACCOUNT_PROFILE_EDIT: [base, '/account/profile/edit'].join(''),
  ACCOUNT_SETTINGS: [base, '/account/settings'].join(''),
  ACCOUNT_API_TOKENS: [base, '/account/api-tokens'].join(''),
  ACCOUNT_DEVICES: [base, '/account/devices'].join(''),
  USERS: [base, '/users'].join(''),

  /**
   * Artifacts
   */
  ARTIFACTS: [base, '/artifacts'].join(''),
  ARTIFACTS_EXPLORE: [base, '/artifacts/explore'].join(''),
  ARTIFACTS_INGEST_STATUS: [base, '/artifacts/ingest-status'].join(''),
  ARTIFACTS_CLOUD: [base, '/artifacts/cloud'].join(''),
  ARTIFACTS_CLOUD_BOX: [base, '/artifacts/cloud/box'].join(''),
  ARTIFACTS_CLOUD_DUO: [base, '/artifacts/cloud/duo'].join(''),
  ARTIFACTS_CLOUD_GOOGLE: [base, '/artifacts/cloud/google'].join(''),
  ARTIFACTS_CLOUD_MERAKI: [base, '/artifacts/cloud/meraki'].join(''),
  ARTIFACTS_CLOUD_O365: [base, '/artifacts/cloud/o365'].join(''),
  ARTIFACTS_CLOUD_OKTA: [base, '/artifacts/cloud/okta'].join(''),
  ARTIFACTS_CLOUD_AZURE: [base, '/artifacts/cloud/azure'].join(''),
  ARTIFACTS_CLOUD_AWS: [base, '/artifacts/cloud/aws'].join(''),
  ARTIFACTS_CLOUD_AWS_CLOUDTRAIL: [
    base,
    '/artifacts/cloud/aws/cloud-trail'
  ].join(''),
  ARTIFACTS_CLOUD_SONICWALL_CSE: [base, '/artifacts/cloud/sonicwall-cse'].join(
    ''
  ),
  ARTIFACTS_DARKWEB: [base, '/artifacts/darkweb'].join(''),
  ARTIFACTS_DARKWEB_CREDENTIALS: [base, '/artifacts/darkweb/credentials'].join(
    ''
  ),
  ARTIFACTS_DARKWEB_KEYWORDS: [base, '/artifacts/darkweb/keywords'].join(''),
  ARTIFACTS_DARKWEB_RANSOMS: [base, '/artifacts/darkweb/ransoms'].join(''),
  ARTIFACTS_ENDPOINT: [base, '/artifacts/endpoint'].join(''),
  ARTIFACTS_ENDPOINT_SYSLOG: [base, '/artifacts/endpoint/syslog'].join(''),
  ARTIFACTS_ENDPOINT_CROWDSTRIKE: [
    base,
    '/artifacts/endpoint/crowdstrike'
  ].join(''),
  ARTIFACTS_ENDPOINT_SENTINELONE: [
    base,
    '/artifacts/endpoint/sentinelone'
  ].join(''),
  ARTIFACTS_ENDPOINT_SENTINELONE_THREATS: [
    base,
    '/artifacts/endpoint/sentinelone/threats'
  ].join(''),
  ARTIFACTS_ENDPOINT_SENTINELONE_AGENTS: [
    base,
    '/artifacts/endpoint/sentinelone/agents'
  ].join(''),
  ARTIFACTS_ENDPOINT_SENTINELONE_ACTIVITIES: [
    base,
    '/artifacts/endpoint/sentinelone/activities'
  ].join(''),
  ARTIFACTS_ENDPOINT_SENTINELONE_STAR_RULES: [
    base,
    '/artifacts/endpoint/sentinelone/star-rules'
  ].join(''),
  ARTIFACTS_ENDPOINT_WINDOWS: [base, '/artifacts/endpoint/windows'].join(''),
  ARTIFACTS_ENDPOINT_DEFENDER_365: [
    base,
    '/artifacts/endpoint/defender-365'
  ].join(''),
  ARTIFACTS_ENDPOINT_DEFENDER_XDR: [
    base,
    '/artifacts/endpoint/defender-xdr'
  ].join(''),
  ARTIFACTS_NETWORK: [base, '/artifacts/network'].join(''),
  ARTIFACTS_NETWORK_BEHAVIORS: [base, '/artifacts/network/behaviors'].join(''),
  ARTIFACTS_NETWORK_SIGNATURES: [base, '/artifacts/network/signatures'].join(
    ''
  ),
  ARTIFACTS_NETWORK_THREATINTEL: [
    base,
    '/artifacts/network/threat-intelligence'
  ].join(''),
  ARTIFACTS_NETWORK_DCE_RPC: [base, '/artifacts/network/dce-rpc'].join(''),
  ARTIFACTS_NETWORK_DNS: [base, '/artifacts/network/dns'].join(''),
  ARTIFACTS_NETWORK_FILES: [base, '/artifacts/network/files'].join(''),
  ARTIFACTS_NETWORK_FTP: [base, '/artifacts/network/ftp'].join(''),
  ARTIFACTS_NETWORK_HTTP: [base, '/artifacts/network/http'].join(''),
  ARTIFACTS_NETWORK_KERBEROS: [base, '/artifacts/network/kerberos'].join(''),
  ARTIFACTS_NETWORK_MYSQL: [base, '/artifacts/network/mysql'].join(''),
  ARTIFACTS_NETWORK_SMB: [base, '/artifacts/network/smb'].join(''),
  ARTIFACTS_NETWORK_SMTP: [base, '/artifacts/network/smtp'].join(''),
  ARTIFACTS_NETWORK_SSH: [base, '/artifacts/network/ssh'].join(''),
  ARTIFACTS_NETWORK_SSL: [base, '/artifacts/network/ssl'].join(''),
  ARTIFACTS_NETWORK_TUNNEL: [base, '/artifacts/network/tunnel'].join(''),
  ARTIFACTS_ICS: [base, '/artifacts/ics'].join(''),
  ARTIFACTS_ICS_BACNET: [base, '/artifacts/ics/bacnet'].join(''),
  ARTIFACTS_ICS_ENIP_CIP: [base, '/artifacts/ics/enip-cip'].join(''),
  ARTIFACTS_ICS_DNP3: [base, '/artifacts/ics/dnp3'].join(''),
  ARTIFACTS_ICS_ETHERNET_IP: [base, '/artifacts/ics/ethernet-ip'].join(''),
  ARTIFACTS_ICS_HART: [base, '/artifacts/ics/hart'].join(''),
  ARTIFACTS_ICS_MODBUS: [base, '/artifacts/ics/modbus'].join(''),
  ARTIFACTS_ICS_OPC_UA: [base, '/artifacts/ics/opc-ua'].join(''),
  ARTIFACTS_ICS_PROFINET: [base, '/artifacts/ics/profinet'].join(''),
  ARTIFACTS_ICS_S7: [base, '/artifacts/ics/s7'].join(''),
  ARTIFACTS_ICS_SYNCHROPHASOR: [base, '/artifacts/ics/synchrophasor'].join(''),
  ARTIFACTS_NETWORK_FILEEXTRACTION: [
    base,
    '/artifacts/network/file-extraction'
  ].join(''),
  ARTIFACTS_PHYSICAL: [base, '/artifacts/physical'].join(''),
  ARTIFACTS_PHYSICAL_SURVEILLANCE: [
    base,
    '/artifacts/physical/surveillance'
  ].join(''),
  ARTIFACTS_PHYSICAL_POINTOFENTRY: [
    base,
    '/artifacts/physical/point-of-entry'
  ].join(''),
  ARTIFACTS_VULNS: [base, '/artifacts/vulnerabilities'].join(''),
  ARTIFACTS_VULNS_NESSUS: [base, '/artifacts/vulnerabilities/nessus'].join(''),
  ARTIFACTS_VULNS_OPENVAS: [base, '/artifacts/vulnerabilities/openvas'].join(
    ''
  ),
  ARTIFACTS_VULNS_QUALYS: [base, '/artifacts/vulnerabilities/qualys'].join(''),

  /**
   * Singular data types with base route
   * Most of these will live under /manage in routes
   * But we want them to be accessible from a base route
   */
  ADVISORIES: [base, '/advisories'].join(''),
  ALERTS: [base, '/alerts'].join(''),
  APPLIANCES: [base, '/appliances'].join(''),
  BOOKMARKS: [base, '/bookmarks'].join(''),
  CASES: [base, '/cases'].join(''),
  DETECTIONS: [base, '/detections'].join(''),
  FILTERS: [base, '/filters'].join(''),
  INCIDENTS: [base, '/incidents'].join(''),
  NOTIFICATIONS: [base, '/notifications'].join(''),
  NETWORKS: [base, '/networks'].join(''),
  NETWORKS_INVENTORIES: [base, '/networks/inventories'].join(''),
  NETWORKS_TOPOLOGIES: [base, '/networks/topologies'].join(''),
  NETWORKS_ANOMALIES: [base, '/networks/anomalies'].join(''),
  NETWORKS_ALERTS: [base, '/networks/alerts'].join(''),
  NETWORKS_THREAT_INTEL: [base, '/networks/threat-intel'].join(''),
  NETWORKS_SETTINGS: [base, '/networks/settings'].join(''),
  ORGANIZATIONS: [base, '/organizations'].join(''),
  POSTS: [base, '/posts'].join(''),
  POSTS_ALL: [base, '/posts/all'].join(''),
  POSTS_ADVISORIES: [base, '/posts/advisories'].join(''),
  POSTS_MANAGE: [base, '/posts/manage'].join(''),
  POSTS_CATEGORIES_MANAGE: [base, '/posts/categories/manage'].join(''),
  POSTS_TAGS_MANAGE: [base, '/posts/tags/manage'].join(''),
  REPORTS: [base, '/reports'].join(''),
  SEARCHES: [base, '/searches'].join(''),
  TICKETS: [base, '/tickets'].join(''),

  /**
   * Resources
   */
  RESOURCES: [base, '/resources'].join(''),
  RESOURCES_DEV_DOCS: [base, '/resources/dev-docs'].join(''),
  RESOURCES_DEV_DOCS_DIRECTORY: [base, '/resources/dev-docs/:path'].join(''),
  RESOURCES_DEV_DOCS_COMPONENT: [
    base,
    '/resources/dev-docs/:directory/:name'
  ].join(''),
  RESOURCES_API_DOCS: [base, '/resources/api-docs'].join(''),
  RESOURCES_API_DOCS_GETTING_STARTED: [
    base,
    '/resources/api-docs/getting-started'
  ].join(''),
  RESOURCES_API_DOCS_AUTH_GUIDE: [base, '/resources/api-docs/auth-guide'].join(
    ''
  ),
  RESOURCES_API_DOCS_ERROR_HANDLING: [
    base,
    '/resources/api-docs/error-handling'
  ].join(''),
  RESOURCES_API_DOCS_CATEGORY: [base, '/resources/api-docs/:categoryId'].join(
    ''
  ),
  RESOURCES_API_DOCS_ENDPOINT: [
    base,
    '/resources/api-docs/:category/:operationSlug'
  ].join(''),
  RESOURCES_NEWS_UPDATES: [base, '/resources/news-updates'].join(''),
  RESOURCES_CHANGE_LOG: [base, '/resources/change-log'].join(''),
  RESOURCES_REPORT_ISSUE: [base, '/resources/report-issue'].join(''),
  TOOLS: [base, '/tools'].join(''),
  TOOLS_IP_LOOKUP: [base, '/tools/aurora'].join(''),

  /**
   * System
   */
  SYSTEM: [base, '/system'].join(''),
  SYSTEM_ADVISORIES: [base, '/system/advisories'].join(''),
  SYSTEM_INDUSTRIES: [base, '/system/industries'].join(''),
  SYSTEM_ALERTS: [base, '/system/alerts'].join(''),
  SYSTEM_BOOKMARKS: [base, '/system/bookmarks'].join(''),
  SYSTEM_DETECTIONS: [base, '/system/detections'].join(''),
  SYSTEM_JOBS: [base, '/system/jobs'].join(''),
  SYSTEM_ORGS: [base, '/system/organizations'].join(''),
  SYSTEM_PRODUCTS: [base, '/system/products'].join(''),
  SYSTEM_PRODUCTS_APPLIANCES: [base, '/system/appliances'].join(''),
  SYSTEM_PRODUCTS_INSTANCES: [base, '/system/products/instances'].join(''),
  SYSTEM_RELEASES: [base, '/system/releases'].join(''),
  SYSTEM_ROLES: [base, '/system/roles'].join(''),
  SYSTEM_SEARCHES: [base, '/system/searches'].join(''),
  SYSTEM_SITES: [base, '/system/sites'].join(''),
  SYSTEM_SUBS: [base, '/system/subscriptions'].join(''),
  SYSTEM_SUBS_LEVELS: [base, '/system/subscriptions/levels'].join(''),
  SYSTEM_TEAMS: [base, '/system/teams'].join(''),
  SYSTEM_USERS: [base, '/system/users'].join(''),
  SYSTEM_PERMISSIONS: [base, '/system/permissions'].join(''),
  SYSTEM_RESOURCES: [base, '/system/resources'].join(''),
  SYSTEM_FIELDS: [base, '/system/fields'].join(''),
  SYSTEM_INDICES: [base, '/system/indices'].join(''),
  SYSTEM_DASHBOARDS: [base, '/system/dashboards'].join(''),
  SYSTEM_MENUS: [base, '/system/menus'].join(''),
  SYSTEM_ROUTES: [base, '/system/routes'].join(''),
  SYSTEM_VISUALIZATIONS: [base, '/system/visualizations'].join(''),
  SYSTEM_SETTINGS: [base, '/system/settings'].join(''),
  SYSTEM_SETTINGS_GENERAL: [base, '/system/settings/general'].join(''),
  SYSTEM_SETTINGS_PRIVACY: [base, '/system/settings/privacy'].join(''),
  SYSTEM_SETTINGS_NOTIFICATION: [base, '/system/settings/notification'].join(
    ''
  ),
  SYSTEM_INTEGRATIONS: [base, '/system/integrations'].join(''),
  SYSTEM_TOOLS: [base, '/system/tools'].join(''),
  SYSTEM_TOOLS_ES: [base, '/system/search-cluster'].join(''),
  SYSTEM_TOOLS_ES_AUDIT_LOGS: [base, '/system/search-cluster/audit-logs'].join(
    ''
  ),
  SYSTEM_TOOLS_ES_HEALTH: [base, '/system/search-cluster/health'].join(''),
  SYSTEM_TOOLS_ES_INDICES: [base, '/system/search-cluster/indices'].join(''),
  SYSTEM_TOOLS_ES_NODES: [base, '/system/search-cluster/nodes'].join(''),
  SYSTEM_TOOLS_DB: [base, '/system/db-cluster'].join(''),
  SYSTEM_TOOLS_DB_HEALTH: [base, '/system/database-cluster/health'].join(''),
  SYSTEM_TOOLS_DB_NODES: [base, '/system/database-cluster/nodes'].join(''),
  SYSTEM_TOOLS_DB_COLLECTIONS: [
    base,
    '/system/database-cluster/collections'
  ].join(''),
  SYSTEM_TOOLS_DB_ROLES: [base, '/system/database-cluster/roles'].join(''),
  SYSTEM_TOOLS_DB_USERS: [base, '/system/database-cluster/users'].join(''),
  SYSTEM_TOOLS_DB_AUDIT_LOGS: [
    base,
    '/system/database-cluster/audit-logs'
  ].join(''),
  SYSTEM_REPORTS: [base, '/system/reports'].join(''),
  SYSTEM_REPORTS_CREATE: [base, '/system/reports/create'].join(''),
  SYSTEM_REPORTS_SETTINGS: [base, '/system/reports/settings'].join(''),
  SYSTEM_REPORTS_TYPES: [base, '/system/reports/types'].join(''),
  SYSTEM_TOOLS_Alerting: [base, '/system/tools/alerting'].join('')
};

export const apiRoutes = {
  REGISTER: '/v1/account/register',
  ACTIVATE: '/v1/account/activate',
  LOGIN: '/v1/account/auth/login',
  REFRESH: '/v1/account/auth/refresh',
  LOCK: '/v1/account/auth/lock',
  UNLOCK: '/v1/account/auth/unlock',
  LOGOUT: '/v1/account/auth/logout',
  MFA_APP_QRCODE: '/v1/account/security/mfa/app/qr',
  MFA_APP_SECRET: '/v1/account/security/mfa/app/secret',
  MFA_APP_VERIFY: '/v1/account/auth/verify',
  PASSWORD_RESET_REQUEST: '/v1/account/security/password/reset-request',
  PASSWORD_RESET_VERIFY: '/v1/account/security/password/reset-verify',
  PASSWORD_RESET: '/v1/account/security/password/reset',
  ACCOUNT_SECURITY_UPDATE_PASSWORD: '/v1/account/security/password/update',
  ACCOUNT_DETAILS: '/v1/account/details',
  GET_ALERT_HELP: '/v1/system/integrations/chatgpt/alert-help',
  ACTIVITY: '/v1/activity',
  REPORTS: '/v1/reports',
  JOBS: '/v1/system/application/jobs',
  JOBS_START: '/v1/system/application/jobs/start',
  JOBS_PAUSE: '/v1/system/application/jobs/pause',
  INDICES: '/v1/system/application/indices',
  FIELDS: '/v1/system/application/fields',
  SYSTEM_CLUSTER_HEALTH: '/v1/system/cluster/health',
  SYSTEM_CLUSTER_STATS: '/v1/system/cluster/stats',
  SYSTEM_CLUSTER_STATE: '/v1/system/cluster/state',
  SYSTEM_CLUSTER_PENDING_TASKS: '/v1/system/cluster/pending-tasks',
  SYSTEM_CLUSTER_NODES: '/v1/system/cluster/nodes',
  SYSTEM_CLUSTER_NODES_INFO: '/v1/system/cluster/nodes-info',
  SYSTEM_CLUSTER_NODES_STATS: '/v1/system/cluster/nodes-stats',
  SYSTEM_CLUSTER_INDICES_STATS: '/v1/system/cluster/index-stats',
  SYSTEM_CLUSTER_INDICES_ALIASES: '/v1/system/cluster/index-aliases',
  SYSTEM_CLUSTER_QUERY_SANKEY: '/v1/system/cluster/query/sankey',
  SYSTEM_CLUSTER_QUERY_SEARCH: '/v1/system/cluster/query/search',
  SYSTEM_CLUSTER_QUERY_COUNT: '/v1/system/cluster/query/count',
  SYSTEM_CLUSTER_QUERY_COUNT_SERIES: '/v1/system/cluster/query/count-series',
  SYSTEM_CLUSTER_QUERY_AGG: '/v1/system/cluster/query/aggregate',
  SYSTEM_CLUSTER_QUERY_FLAT_AGG: '/v1/system/cluster/query/flat-aggregate',
  SYSTEM_CLUSTER_QUERY_MAPPINGS: '/v1/system/cluster/query/mappings',
  SYSTEM_CLUSTER_QUERY_HISTOGRAM: '/v1/system/cluster/query/histogram',
  SYSTEM_CLUSTER_QUERY_AUDIT_LOGS: '/v1/system/cluster/query/audit-logs',
  SYSTEM_CLUSTER_TRANSLOG_OPERATIONS:
    '/v1/system/cluster/cluster-nodes/health-hero-chart',
  SYSTEM_DASHBOARDS: '/v1/system/application/dashboards',
  SYSTEM_RELEASES: '/v1/system/application/releases',
  SYSTEM_TEAMS: '/v1/system/application/teams',
  SYSTEM_BOOKMARKS: '/v1/system/application/bookmarks',
  SYSTEM_ALERTS: '/v1/system/application/alerts',
  SYSTEM_SEARCHES: '/v1/system/application/saved-searches',
  MANAGE_SAVED_QUERIES: '/v1/manage/saved-searches',
  SYSTEM_RELEASES_NOTES: '/v1/system/application/releases/notes',
  SYSTEM_USERS: '/v1/system/application/users',
  SYSTEM_ORGS: '/v1/system/application/organizations',
  SYSTEM_SUBS_LEVELS: '/v1/system/application/subscriptions/levels',
  SYSTEM_REPORTS: '/v1/system/application/reports',
  SYSTEM_REPORTS_GENERATE: '/v1/system/application/reports/generate',
  SYSTEM_PRODUCTS: '/v1/system/application/products',
  SYSTEM_PRODUCTS_APPLIANCES: '/v1/system/application/appliances',
  ACCOUNT_ORGANIZATIONS: '/v1/account/organizations',
  ACCOUNT_ALERTS: '/v1/account/alerts',
  ROLES: '/v1/system/application/roles',
  RESOURCES: '/v1/system/application/resources',
  ORGANIZATIONS: '/v1/manage/organizations',
  APPLIANCES: '/v1/manage/appliances',
  TICKETS: '/v1/manage/tickets',
  CASES: '/v1/manage/cases',
  INCIDENTS: '/v1/manage/incidents',
  BOARDS: '/v1/manage/boards',
  LOCATIONS: '/v1/manage/locations',
  NOTIFICATIONS: '/v1/manage/notifications',
  SCANS: '/v1/manage/scans',
  SCOPES: '/v1/manage/scopes',
  SERVICES: '/v1/manage/services',
  SUBSCRIPTIONS: '/v1/manage/subscriptionLevels',
  TEAMS: '/v1/manage/teams',
  THREATS: '/v1/manage/threats'
};

export default routes;
